import { Component } from "@angular/core";

@Component({
  selector: "app-q-form-group-heading",
  templateUrl: "./q-form-group-heading.component.html",
  styleUrls: ["./q-form-group-heading.component.scss"],
})
export class QFormGroupHeadingComponent {}
